export const isAuthenticated = () => !!localStorage.getItem('token');

export const getAuthHeader = () => {
  const t = localStorage.getItem('token');
  return t ? { Authorization: `Bearer ${t}` } : {};
};
